import React from 'react';
import Icon from 'components/Icon';
import { getType } from 'util/mediaUtil';
import styles from 'components/MediaIcon.css';

const MediaIcon = ({ media, ...props }) => {
  const mediaType = getType(media);

  return (
    <div {...props}>
      <Icon className={styles[mediaType]} value={mediaType} />
    </div>
  );
};

export default MediaIcon;
